module.exports = __webpack_public_path__ + "static/media/patrimony.eb3ea4e7.svg";